import React from 'react';
import { observer } from 'mobx-react';
import { Icon, Image } from 'semantic-ui-react';
import { SatCoreRegister } from '../SatCoreRegistry';

import '../css/GradebookKeyViewMoreModalContent.less';

import iconInstructions from '../img/icon-instructions.svg';
import iconSurvey from '../img/icon-survey.svg';
import { ReactComponent as IconView } from '../img/icon-view.svg';

import { getContentTypeIcon } from '../utils';

const gradebookKeyModalTableData = [
  [
    { icon: <span className='key-icon'>—</span>, label: 'noResponse' },
    { icon: <Icon className='pencil-icon' name='pencil' size='large' />, label: 'requiresManualScore' },
    { icon: <IconView className='view-icon' />, label: 'view' },
  ],
  [
    { icon: <div className='square full-credit' />, label: 'fullCredit' },
    { icon: <div className='square partial-credit' />, label: 'partialCredit' },
    { icon: <div className='square no-credit' />, label: 'noCredit' },
  ],
  [
    { icon: <Image className='image-icon' src={iconInstructions} />, label: 'studentInstructions' },
    { icon: <Image className='image-icon' src={iconSurvey} />, label: 'surveyResponse' },
    { icon: <Image className='image-icon' src={getContentTypeIcon('UserFile')} />, label: 'userFile' },
  ],
  [
    { icon: <Image className='image-icon' src={getContentTypeIcon('WebPage')} />, label: 'webPage' },
    { icon: <Image className='image-icon' src={getContentTypeIcon('Audio')} />, label: 'audioContent' },
    { icon: <Image className='image-icon' src={getContentTypeIcon('ArticleResource')} />, label: 'articleResource' },
  ],
  [
    { icon: <Image className='image-icon' src={getContentTypeIcon('Pdf')} />, label: 'pdfFile' },
    { icon: <Image className='image-icon' src={getContentTypeIcon('Video')} />, label: 'videoContent' },
    { icon: <Image className='image-icon' src={getContentTypeIcon('Image')} />, label: 'imageContent' },
  ]
];

const GradebookKeyViewMoreModalContent = observer((props) => {
  const { t } = props;
  return (
    <div className='gradebook-key-modal-content'>
      <table className='gradebook-key-modal-table'>
        <tbody>
          {gradebookKeyModalTableData.map((row, rowIdx) => (
            <tr key={rowIdx} className='gradebook-key-modal-row'>
              {row.map((item, colIdx) => (
                <td key={colIdx} className='gradebook-key-modal-item'>
                  <span className='gradebook-key-modal-item-inner'>
                    <span className='gradebook-key-modal-item-icon'>{item.icon}</span>
                    <span className='gradebook-key-modal-item-label'>{t(item.label)}</span>
                  </span>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default GradebookKeyViewMoreModalContent;

SatCoreRegister('GradebookKeyViewMoreModalContent', GradebookKeyViewMoreModalContent);
